import { breakpoints } from './size'

const { tablet, mobile } = breakpoints

const screen = {
   onlyDesktop: `@media only screen and (orientation:landscape)`,
   onlyTablet: `@media only screen and (min-width: ${mobile}px) and (max-width: ${tablet}px) and (orientation: portrait)`,
   onlyMobile: `@media only screen and (max-width: ${mobile}px) and (orientation: portrait)`,

   tabletAndMobile: `@media only screen and (orientation: portrait)`,

   showOnDesktopOnly: `@media only screen and (orientation:portrait) {display: none !important;}`,
   showOnTabletOnly: `@media only screen and (max-width: ${mobile}px) , (orientation: landscape) {display: none !important;}`,
   showOnMobileOnly: `@media only screen and (min-width: ${mobile}px),(orientation: landscape) {display: none !important;}`,

   showOnDesktopAndTablet: `@media only screen and (max-width: ${mobile}px) {display: none !important;}`,
   showOnTabletAndMobile: `@media only screen and (orientation: landscape) {display: none !important;}`,
}

export default screen
